import { Component, OnInit } from "@angular/core";
import { constants } from "../../../utils/constants";
import { RequestService } from "../../../services/request.service";
import { AuthService } from "../../../services/auth.service";
import { IErrorAlert } from "src/app/interfaces/error.interface";
import { RequestModel } from "../../../models/request.model";

@Component({
  selector: "app-last-requests",
  templateUrl: "./last-requests.component.html",
  styleUrls: ["./last-requests.component.css", "../../pages.component.css"],
})
export class LastRequestsComponent implements OnInit {
  constants = constants;

  requests: RequestModel[];
  loading: boolean = true;
  error: IErrorAlert = null;

  //Pagination
  config;

  constructor(public _request: RequestService, public _auth: AuthService) {}

  ngOnInit(): void {
    const idNumber = this._auth.user.getUserData().idNumber;
    this._request.getRequestHistory(idNumber).subscribe(
      (requests: RequestModel[]) => {
        this.requests = requests;
        this.setPaginationConfig(requests.length);
        this.loading = false;
      },
      (err) => {
        this.error = err;
        this.loading = false;
      }
    );
  }

  setPaginationConfig(length: number) {
    this.config = {
      id: "custom",
      itemsPerPage: 3,
      currentPage: 1,
      totalItems: length,
    };
  }
}
